import dayjs from 'dayjs';
import { InsuranceMode } from '../../constants';

const validateInsurance = (trip, insuranceInfo, insuranceTripInfo) => {
  const optionsFormValidations = {};
  const tripInfoFormValidations = {};
  if (trip.insuranceItinerary?.insuranceMode === InsuranceMode.Standalone) {
    if (!insuranceInfo) optionsFormValidations.selectedPlan = 'Insurance plan is required.';
    if (!insuranceTripInfo?.startDate)
      tripInfoFormValidations.startDate = 'Departure date is required';
    if (!insuranceTripInfo?.endDate) tripInfoFormValidations.endDate = 'Return date is required';
    if (!insuranceTripInfo?.depositDate)
      tripInfoFormValidations.depositDate = 'Deposit date is required';
    if (
      insuranceTripInfo?.tripCost === undefined ||
      insuranceTripInfo?.tripCost === null ||
      Number(insuranceTripInfo.tripCost) < 0
    )
      tripInfoFormValidations.tripCost = 'Total trip cost must be 0 or greater';
    if (
      !trip.cruiseItinerary &&
      (!insuranceTripInfo?.destinations || insuranceTripInfo.destinations.length === 0)
    )
      tripInfoFormValidations.destinations = 'At least one destination is required';

    if (
      insuranceTripInfo?.startDate &&
      insuranceTripInfo?.endDate &&
      dayjs(insuranceTripInfo.startDate).isAfter(dayjs(insuranceTripInfo.endDate))
    ) {
      tripInfoFormValidations.endDate = 'Return date must be the same or later than departure date';
    }
  }

  const isValid =
    Object.keys(tripInfoFormValidations).length === 0 &&
    Object.keys(optionsFormValidations).length === 0;
  return [isValid, tripInfoFormValidations, optionsFormValidations];
};

export default validateInsurance;
